import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useDispatch } from "react-redux";

import FormDisplay from "./FormDisplay";
import validationSchema from "../validationSchema";
import { objectFromFormData } from "../broadcastDetailsObject";
import { useAxios } from "../../../../../hooks";
import { alert } from "../../../../../redux/slices/alertSlice";
import { ButtonFooter } from "../../../../../components";

export default function MessageDisplayForm({
  formData,
  activeBot,
  setFormData,
  groupList,
  scheduledTime,
  setScheduledTime,
  template,
  channel,
  fields,
}) {
  const axios = useAxios({ disableAuthToken: true });
  const dispatch = useDispatch();

  const [editState, setEditState] = useState(true);

  useEffect(() => {
    if (Boolean(formData.ID)) {
      setEditState(false);
    }
  }, [formData.ID]);

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={formData}
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        var data = objectFromFormData(formData, channel);

        axios({
          url: "/pmc/schedule-sms",
          method: "POST",
          data: data,
        }).then((res) => {
          if (res.status) {
            setSubmitting(false);
            setFormData(formData);
            setEditState(false);
            dispatch(
              alert({
                type: "success",
                message: res.message.displayMessage,
              })
            );
          }
        });
      }}
    >
      {(formikProps) => (
        <React.Fragment>
          <FormDisplay
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
            scheduledTime={scheduledTime}
            setScheduledTime={setScheduledTime}
            groupList={groupList}
            activeBot={activeBot}
            template={template}
            fields={fields}
            channel={channel}
          />

          <ButtonFooter
            ID={formikProps.values.ID}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />
        </React.Fragment>
      )}
    </Formik>
  );
}
